"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryEngineConfig = void 0;
const support_1 = require("./support");
const queryEngineConfig = () => ({
    origin: 'query-engine',
    supportedFeatures: [
        'simpleMaths',
        'aggregateMaths',
        'subquery',
        'configManagerUi',
        'sqlDefinedDataSet',
        'roundedNumbers',
        'switchField',
        'encryptedDashboards',
        'sqlViews',
        'dateMaths',
    ],
    supportedTimeTruncFunctions: (0, support_1.supportedTimeTruncFunctions)([
        'month',
        'year',
        'quarter',
        'week',
        'day',
        'hour',
        'minute',
        'second',
    ]),
    supportedAggregates: (0, support_1.supportedAggregates)(['sum', 'mean', 'min', 'max', 'count', 'countDistinct']),
    supportedOperators: (0, support_1.supportedOperators)([
        '>',
        '<',
        '=',
        '!=',
        '>=',
        '<=',
        'is_one_of',
        'is_not_one_of',
        'starts_with',
        'ends_with',
        'contains_substring',
        'does_not_contain_substring',
        'array_contains',
        'array_does_not_contain',
    ]),
    supportedTransformationFunctions: (0, support_1.supportedTransformationFunctions)(['round_to_0_dp', 'round_to_2_dp']),
});
exports.queryEngineConfig = queryEngineConfig;
